export const CommonSydneyData = [
  {
    title: "Technical Document Translation",
    detail:
      "Our technical document translation services have you in mind, whether you're in the sciences, engineering, or information technology fields. We translate user manuals, product manuals, and more into the over 120 languages available at Tomedes. This includes glossaries of specific terminologies as well.",
    link: "/technical-translation.php",
  },
  {
    title: "Financial Document Translation",
    detail:
      "If you need financial document translations for your business or personal needs, our financial translators at Tomedes can translate your investment portfolios, tax statements, and balance sheets. We make sure they're translated by industry experts, who have the linguistic rigour you need.",
    link: "/financial-translation.php",
  },
  {
    title: "Medical Document Translation",
    detail:
      "Your medical documents like patient charts, lab reports, and clinical findings can all be translated through medical translation services at Tomedes. In Sydney, medical translators can assist with documents and medical interpreters can help with your interpreting needs.",
    link: "/medical-translation.php",
  },
  {
    title: "Legal Document Translation",
    detail:
      "For all legal documents, legal translators can translate using specific terminologies they have the knowledge of in their various fields of law. These fields include civic, criminal, environmental, and corporate law. Not only that, but they also have the linguistic expertise to translate into many languages, over 120, in fact!",
    link: "/legal-translation.php",
  },
  {
    title: "Didn't see the document translation service you were looking for?",
    detail:
      "Tomedes' document translation services are tailored to every need in Sydney, spanning a myriad of industries. Whether it's financial documents, legal documents, or medical documents, our financial, legal and medical translators will handle your translation projects. Add to that a dedicated project manager and 24/7 support: your translations in New South West (NSW) are in safe hands with Tomedes.",
    // link: "/services/translation/",
    link2: " ",
  },
];
